export class FavoritesListItem {
  _favorite;
  _itemEl;

  constructor(favorite) {
    this._favorite = favorite;

    const template = document.querySelector('.js-favs-item-tpl');
    const col = template.content.firstElementChild.cloneNode(true);
    const card = col.querySelector('.card');
    const img = col.querySelector('figure img');
    const title = col.querySelector('.card__link');
    const city = card.querySelector('.card__city');
    const subtitle = card.querySelector('.card__subtitle');
    const price = card.querySelector('.card__price');
    const tagEls = card.querySelector('.card__tags');
    const metasEl = card.querySelector('.card__metas__item');
    const btn = col.querySelector('.js-favs-remove');

    favorite.metas.forEach((meta, index) => {
      if (index === 0) {
        metasEl.textContent = meta;
      } else {
        const metaEl = metasEl.cloneNode();
        metaEl.textContent = meta;
        metasEl.parentNode.append(metaEl);
      }
    })

    favorite.tags.forEach((tag, index) => {
      if (index === 0) {
        tagEls.querySelector('.labels__item').innerHTML = tag;
      } else {
        const tagEl = tagEls.querySelector('.labels__item').cloneNode();
        tagEl.innerHTML = tag;
        tagEls.append(tagEl);
      }
    })

    card.setAttribute('data-item-id', favorite.id);
    img.setAttribute('src', favorite.img);
    title.setAttribute('href', favorite.link);

    title.innerText = favorite.title;
    price.textContent = favorite.price;
    city.innerText = favorite.city;
    subtitle.innerText = favorite.subtitle;

    this._itemEl = col;
    btn.addEventListener('click', (e) => {
      this.remove(e);
    });
  }

  get element() {
    return this._itemEl;
  }

  appendTo(container) {
    container.append(this._itemEl);
  }

  prependTo(container) {
    container.prepend(this._itemEl);
  }

  remove(e) {
    const event = new CustomEvent('delete', {
      detail: this._favorite,
      bubbles: true,
      cancelable: true,
    });
    this._itemEl.dispatchEvent(event);

    if (event.defaultPrevented) {
      return;
    }

    this._itemEl.remove();
  }
}
